module.exports = __webpack_public_path__ + "static/media/favouriteBtn.3bc84652.png";